import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs";

import { LorenAutomationPlanResolverConstant } from "./constants/loren-automation-plans-resolver.constants";
import { LorenAutomationPlan } from "../interfaces/loren-automation-plan.interface";
import { BaseEntityResolver } from "../../../shared/resolvers/loren-base-entity-resolver/base-entity.resolver";
import { LorenAutomationPlanService } from "../services/loren-automation-plan-service/loren-automation-plan.service";
import { LorenAuthenticationService } from "../../../shared/services/loren-authentication-service/loren-authentication.service";
import { LorenErrorHandlingService } from "../../../shared/services/loren-error-handling-service/loren-error-handling-service.service";

@Injectable()
export class LorenAutomationPlanResolver extends BaseEntityResolver<LorenAutomationPlan> {
  protected service: LorenAutomationPlanService;
  private authenticationService = inject(LorenAuthenticationService);
  protected router: Router;
  protected errorHandlingService: LorenErrorHandlingService;

  constructor() {
    const service = inject(LorenAutomationPlanService);
    const router = inject(Router);
    const errorHandlingService = inject(LorenErrorHandlingService);

    super(
      service,
      LorenAutomationPlanResolverConstant.PLAN,
      router,
      errorHandlingService
    );
  
    this.service = service;
    this.router = router;
    this.errorHandlingService = errorHandlingService;
  }

  resolve(route: ActivatedRouteSnapshot): Observable<LorenAutomationPlan> {
    const userId = this.authenticationService.getUserInfo().id;
    const id = route.params[LorenAutomationPlanResolverConstant.PLAN];
    return this.service.getPlan(id, userId);
  }
}
